import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserAuthorizationService } from '../../services/user-authorization.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    encapsulation: ViewEncapsulation.None
})
export class LogoutComponent implements OnInit {

    constructor(
        private authService: UserAuthorizationService
    ) {}

    ngOnInit(): void {
        this.authService.completeOidcLogout();
    }
}
